export default __webpack_public_path__ + "static/media/flag_it.9938f4b9.svg";